import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  Tooltip,
  Skeleton,
  Button
} from 'antd';
import { CustomAlertModal } from '../../../shared';
import { EnvironmentTwoTone } from '@ant-design/icons';
import moment from 'moment';
import { GlobalApiErrorHandler } from '../../../shared/helpers'
import { MsgBox } from '../../../shared/custom-ant-d'
import { isMobile } from 'react-device-detect';
import { reqPostSaveApplication } from '../../../axios/api';

export const SavedApplication = (props) => {
  const JobList = props.jobSavedDraftList;
  const history = useHistory();
  const Auth = useSelector(state => state.Auth);

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [applicationId, setApplicationId] = useState(null);

  const editDraft = (e, jobDetails) => {
    e.preventDefault();

    if (!jobDetails.isPostingActive) {
      MsgBox({
        type: 'error',
        message: '',
        description: 'This job cannot be viewed at this time. It has either been deleted or is no longer available for application.',
      });

      return;
    }

    return history.push({
      pathname: '/job-apply',
      search: "?jobPostingID=" + jobDetails.jobPostingID,
      state: {
        jobDetails: jobDetails
      },
    });
  }

  const openDeleteModal = (e, applicationId) => {
    e.preventDefault();
    setIsDeleteModalVisible(true);
    setApplicationId(applicationId);
  }

  const deleteDraft = (e) => {
    e.preventDefault();
    setIsDeleteModalVisible(false);

    var application = JobList.filter((item, i) => {
      return item.applicationID === applicationId;
    });

    if (application.length > 0) {
      var applicationObj = application[0];

      var jsonData = {
        applicationID: applicationObj.applicationID,
        candidateID: parseInt(applicationObj.candidateID),
        jobReqID: parseInt(applicationObj.jobReqID),
        jobPostingID: parseInt(applicationObj.jobPostingID),
        legalFirstName: Auth.firstName,
        legalLastName: Auth.lastName,
        personalEmail: Auth.personalEmail,
        homeCountryID: Auth.countryID,
        is18OrOlder: false,
        workedAtiQorInd: false,
        isSponsorshipRequired: false,
        availableWeekendInd: false,
        availableEveningInd: false,
        scheduleRestrictionsInd: false,
        action: 'DELETE'
      }
      // debugger
      var formStr = JSON.stringify({ ...applicationObj, ...jsonData });
      props.setIsJobApplicationLoading(true);

      reqPostSaveApplication(formStr)
        .then(res => {
          MsgBox({
            type: 'success',
            message: '',
            description: 'Your application has been deleted'
          });

          props.getProfileDetails(true);
        })
        .catch(err => {
          GlobalApiErrorHandler({ errors: err.response.data.errors });
          console.log(err);
        });
    }
  }


  const Content = () => {
    return (
      <>
        <Row justify="left">
          <Col md={24} xs={24}>
            {
              props.isJobApplicationLoading ? (
                <>
                  <Skeleton active />
                </>
              ) : (
                <>
                  {
                    !isMobile ? (
                      <>
                        <Row>
                          {
                            JobList && JobList.map((item, i) => {
                              return (
                                <div style={{ cursor: 'pointer' }} className="ant-col ant-col-xs-24 ant-col-md-7 jobs-applied-col" key={i}>
                                  <Tooltip placement="topLeft" title={item.postingJobTitle + " - #" + item.jobReqID} arrowPointAtCenter>
                                    <Card title={item.postingJobTitle + " - #" + item.jobReqID} className="jobs-applied saved-applications">
                                      <ul className="hide-list-style">
                                        <li><EnvironmentTwoTone className="inline-icon" twoToneColor="#52c41a" /> {item.postingCity + ", " + (item.postingState ? (item.postingState + ", ") : "") + item.postingCountryCode}</li>
                                        <li>{item.appStatus}</li>
                                        <li>{moment(item.createdDt).format('MM/DD/YYYY')}</li>
                                      </ul>

                                      <Row justify="center" className="center-btns">

                                        <Col>

                                          <Button
                                            //className="center-btn"
                                            type="danger"
                                            htmlType="button"
                                            //style={{
                                            //  bottom: "50px"
                                            //}}
                                            onClick={e => editDraft(e, item)}>
                                            View
                                          </Button>
                                          {" "}
                                          <Button
                                            //className="center-btn"
                                            type="danger"
                                            htmlType="button"
                                            onClick={e => openDeleteModal(e, item.applicationID)}
                                          >
                                            Delete
                                          </Button>

                                        </Col>

                                      </Row>
                                    </Card>
                                  </Tooltip>
                                </div>
                              )

                            })
                          }
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row justify="center">
                          {
                            JobList && JobList.map((item, i) => {
                              return (
                                <div style={{ cursor: 'pointer' }} className="ant-col ant-col-xs-24 ant-col-md-24 jobs-applied-col" key={i}>
                                  <Tooltip placement="topLeft" title={item.postingJobTitle + " - #" + item.jobReqID} arrowPointAtCenter>
                                    <Card title={item.postingJobTitle + " - #" + item.jobReqID} className="jobs-applied saved-applications">
                                      <ul className="hide-list-style">
                                        <li><EnvironmentTwoTone className="inline-icon" twoToneColor="#52c41a" /> {item.postingCity + ", " + (item.postingState ? (item.postingState + ", ") : "") + item.postingCountryCode}</li>
                                        <li>{item.appStatus}</li>
                                        <li>{moment(item.createdDt).format('MM/DD/YYYY')}</li>
                                      </ul>
                                      <Row justify="center" className="center-btns">

                                        <Col>

                                          <Button
                                            //className="center-btn"
                                            type="danger"
                                            htmlType="button"
                                            //style={{
                                            //  bottom: "50px"
                                            //}}
                                            onClick={e => editDraft(e, item)}>
                                            View
                                          </Button>
                                          {" "}
                                          <Button
                                            //className="center-btn"
                                            type="danger"
                                            htmlType="button"
                                            onClick={e => openDeleteModal(e, item.applicationID)}
                                          >
                                            Delete
                                          </Button>

                                        </Col>

                                      </Row>
                                    </Card>
                                  </Tooltip>
                                </div>
                              )

                            })
                          }
                        </Row>
                      </>
                    )
                  }
                </>
              )
            }
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <Row justify="center">
        <Col sm={23} xs={24}>
          <Card title="Saved Applications" className="iqor-header">
            {
              (props.isProfileLoading || props.isJobApplicationLoading) ? (<Skeleton active />) : (<Content />)
            }
          </Card>
        </Col>
      </Row>

      <CustomAlertModal
        type="confirm"
        content="Are you sure you want to delete your application?"
        onCancel={() => { setIsDeleteModalVisible(false) }}
        visible={isDeleteModalVisible}
        destroyOnClose={true}
        footer={[
          <Button
            key='yes'
            onClick={e => deleteDraft(e)}
            type="danger"
          >
            Yes
          </Button>,
          <Button
            key='no'
            onClick={e => setIsDeleteModalVisible(false)}
            type="danger"
          >
            No
          </Button>
        ]}
      />
    </>
  )
}
